import { useEffect, useState } from "react";
import { AuthProfile } from "../../../../redux/features/auth/auth.types";
import { useAppSelector } from "../../../../redux/hooks";
import { clientProfileCookieKey } from "../../../../utils/constants";
import { getCookie } from "../../../../utils/helpers";
import { ProfileIcon } from "../../../cards/profilePic";
import Dropdown from "../../../dropdown/dropdown";
import { Icon } from "../../../icon/icon";

export const ProfileDetails = ({
  className = "",
  profileClassName = "!p-3",
  profileDimension = 64,
  useCookieProfile = false,
}: {
  className?: string;
  profileClassName?: string;
  profileDimension?: number;
  useCookieProfile?: boolean;
}) => {
  const [profile, setProfile] = useState<AuthProfile | null>(null);

  const { profile: stateProfile } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (useCookieProfile) {
      const cookieProfile: AuthProfile = getCookie(clientProfileCookieKey)
        ? JSON.parse(getCookie(clientProfileCookieKey)!)
        : undefined;

      setProfile(cookieProfile);
    } else {
      setProfile(stateProfile);
    }
  }, [useCookieProfile, stateProfile]);

  return (
    <div
      className={`flex flex-col items-center justify-center rounded-md bg-white p-3 text-center ${className}`}
    >
      <ProfileIcon
        dimension={profileDimension}
        className={profileClassName}
        img={undefined}
      />

      <p className="mt-2 text-base font-bold">
        {profile?.firstName} {profile?.lastName}
      </p>
      <p className="text-sm text-grey-500">{profile?.email}</p>
    </div>
  );
};

export const ProfileDropdown = ({
  dropDownOptions,
  useCookieProfile = false,
  className = "",
}: {
  dropDownOptions: {
    icon: string;
    label: string;
    onClick: () => void;
  }[];
  useCookieProfile?: boolean;
  className?: string;
}) => {
  const { profile: stateProfile } = useAppSelector((state) => state.auth);

  const cookieProfile: AuthProfile = getCookie(clientProfileCookieKey)
    ? JSON.parse(getCookie(clientProfileCookieKey)!)
    : undefined;

  const profile = useCookieProfile ? cookieProfile : stateProfile;

  return (
    <Dropdown
      menuItems={[
        {
          name: (
            <ProfileDetails
              className="!cursor-default !items-start !justify-start !p-3"
              profileDimension={32}
              profileClassName="!p-[6px]"
              useCookieProfile={useCookieProfile}
            />
          ),
          onClick: (e) => {
            e?.preventDefault();
            e?.stopPropagation();
          },
        },
        ...dropDownOptions.map((option) => {
          return {
            name: (
              <p className="soft-shrink flex items-center gap-2 !rounded-md !bg-white p-3 text-left !font-bold">
                <Icon
                  svg={option.icon}
                  width={20}
                  height={20}
                  className="!min-w-fit text-grey-400"
                />
                <span>{option.label}</span>
              </p>
            ),
            onClick: option.onClick,
          };
        }),
      ]}
      className={className}
      menuClassName="!gap-1 !border-0 !bg-grey-50 !p-1 !min-w-[300px] !z-[998]"
      menuItemsClassName="border-none !text-base !bg-transparent !p-0"
      position="bottom end"
    >
      <button className="flex w-fit items-center gap-1">
        <p className="hidden max-w-[154px] items-center gap-[6px] rounded-full bg-white py-2.5 pl-2 pr-3 text-base font-bold md:flex">
          <ProfileIcon img="" dimension={32} className="" />

          <span className="line-clamp-1 block text-ellipsis">
            {profile?.firstName}
          </span>
        </p>

        <Icon
          svg="caret-down"
          width={52}
          height={52}
          className="rounded-full bg-white p-[14px] text-black"
        />
      </button>
    </Dropdown>
  );
};
